import * as React from "react";

import { KeyCodeEnum } from "constants/keyCode";

export enum KeyModifier {
  Alt = "altKey",
  Control = "ctrlKey",
  Shift = "shiftKey",
  Meta = "metaKey",
}

interface IShortcutConfiguration {
  [key: string]: {
    additionalKeysRequired?: KeyModifier[];
    disableDefaultBehavior?: boolean;
    eventHandler: () => void;
    shouldWorkWhenInputFocused?: boolean;
    shouldNotBlurOnEscapeClick?: boolean;
  };
}

interface IProps {
  config: IShortcutConfiguration;
  children?: React.ReactNode;
  disableShortcuts?: boolean;
}

export class ShortcutsComponent extends React.PureComponent<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private blurOnEscape = () => {
    const activeElement = document.activeElement as HTMLElement | null;
    if (activeElement) {
      activeElement.blur();
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private isInputOrTextAreaFocused = () => {
    const activeElement = document.activeElement as HTMLElement | null;
    return (
      activeElement &&
      (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA" || activeElement.isContentEditable)
    );
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleKeyDown = (e: KeyboardEvent) => {
    const config = this.props.config[e.keyCode];

    if (
      e.keyCode === KeyCodeEnum.Esc &&
      this.isInputOrTextAreaFocused() &&
      (!config || !config.shouldNotBlurOnEscapeClick)
    ) {
      this.blurOnEscape();
      return null;
    }

    if (
      !config ||
      this.props.disableShortcuts ||
      (!config.shouldWorkWhenInputFocused && this.isInputOrTextAreaFocused())
    ) {
      return null;
    }

    let keyModifiersConfig = {
      [KeyModifier.Alt]: false,
      [KeyModifier.Control]: false,
      [KeyModifier.Shift]: false,
      [KeyModifier.Meta]: false,
    };

    if (config.additionalKeysRequired) {
      config.additionalKeysRequired.forEach(keyName => {
        keyModifiersConfig = { ...keyModifiersConfig, [keyName]: true };
      });
    }

    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const isAnyKeyConfigIncorrect = Object.keys(keyModifiersConfig).some(item => keyModifiersConfig[item] !== e[item]);

    if (isAnyKeyConfigIncorrect) {
      return null;
    }

    if (config.disableDefaultBehavior) {
      e.preventDefault();
    }

    return config.eventHandler();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    return this.props.children;
  }
}

export const Shortcuts = ShortcutsComponent;
